import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { SIX_DIGITS_REGEX } from '@/regex.constants';

interface TwoFactorStore {
  twoFactorCode: string | null;
  isTwoFactorDialogVisible: boolean;
  isTwoFactorAuthLoading: boolean;
}

export const useTwoFactorStore = defineStore({
  id: 'TwoFactorStore',
  state: (): TwoFactorStore => ({
    twoFactorCode: null,
    isTwoFactorDialogVisible: false,
    isTwoFactorAuthLoading: false,
  }),
  getters: {
    isEnteredCodeFormallyValid(): boolean {
      return Boolean(this.twoFactorCode && SIX_DIGITS_REGEX.test(this.twoFactorCode));
    },
  },
  actions: {
    setTwoFactorCode(code: string): void {
      this.twoFactorCode = code;
    },
    setTwoFactorDialogVisibility(isVisible: boolean): void {
      this.isTwoFactorDialogVisible = isVisible;
    },
    openTwoFactorDialog(): void {
      this.setTwoFactorDialogVisibility(true);
    },
    closeTwoFactorDialog(): void {
      this.twoFactorCode = null;
      this.setTwoFactorDialogVisibility(false);
    },
    setTwoFactorLoading(isLoading: boolean): void {
      this.isTwoFactorAuthLoading = isLoading;
    },
    checkTwoFactorCode(code: string): Promise<boolean> {
      this.setTwoFactorLoading(true);

      return api.auth.twoFactorCodeRequest.perform({ code })
        .then((isCodeValid) => {
          return isCodeValid;
        })
        .finally(() => {
          this.setTwoFactorLoading(false);
        });
    },
  },
});
